import React, {useCallback, useContext, useEffect, useState} from 'react';
import { IUser, IUseData } from '../constants/types';

export const DataContext = React.createContext({});

export const DataProvider = ({children}: {children: React.ReactNode}) => {
  const [appIsReady, setAppIsReady] = useState(false);
  const [user, setUser] = useState<IUser>();

  // handle user
  const handleUser = useCallback(
    (payload: IUser) => {
      // set user / compare if has updated
      console.log("Handle User ======== ===========================");
      if (JSON.stringify(payload) !== JSON.stringify(user)) {
        setUser(payload);
      }
    },
    [user, setUser],
  );

  const logoutUser = useCallback(() => {
    setUser(undefined);
    localStorage.removeItem('user');
    console.log("set user undefined");
  }, [user, setUser]);
  
  const saveUser = useCallback((value: IUser) => {
      console.log("saveUser=" + JSON.stringify(value));
      setUser(value);
      localStorage.setItem('user', JSON.stringify(value));
    },
    [user, setUser],
  );

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setAppIsReady(true);
  }, []);

  const contextValue = {
    appIsReady, setAppIsReady,
    saveUser,
    logoutUser,
    user,
    handleUser,
  };

  return (
    <DataContext.Provider value={contextValue}>{children}</DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext) as IUseData;
